import React from 'react'
import { IIconProps } from './types'
import { Svg } from './Misc'

export const AlertTriangleIcon = (props: IIconProps): React.ReactElement => (
  <Svg
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <title>{'Warning Icon'}</title>
    <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4M12 17h.01" />
  </Svg>
)
